import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { Feedback } from '../elements/common';
import { Component } from '../elements/Component';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';

interface IUsernameInputProps {
    autoFocus?: boolean;
    disabled?: boolean;
    error?: string;
    name?: string;
    onChange: (value: string) => void;
    onDoValidate?: () => void;
    placeholder: string;
    value: string;
}

export class UsernameInput extends Component<FormContextProps<IUsernameInputProps>> {
    private changed = false;
    public render() {
        return (
            <FormContextConsumer {...this.props}>
                {(properties) => (
                    <>
                        <div
                            className="input-container"
                            key="container"
                        >
                            <input
                                autoFocus={properties.autoFocus}
                                className={'form-control input-lg' + (properties.error ? ' form-control-danger' : '')}
                                disabled={properties.disabled}
                                name={properties.name}
                                onBlur={() => {
                                    if (properties.onDoValidate && this.changed) {
                                        properties.onDoValidate();
                                    }
                                }}
                                onChange={(e) => {
                                    this.changed = true;
                                    properties.onChange(e.target.value);
                                }}
                                placeholder={properties.placeholder}
                                type="text"
                                value={properties.value}
                            />
                        </div>
                        <Feedback
                            error={properties.error}
                            key="feedback"
                        />
                    </>
                )}
            </FormContextConsumer>
        );
    }
}

export function UsernameField(props: FormContextProps<IUsernameInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <UsernameInput {...props} />
        </Field>
    );
}
